module.exports = __webpack_public_path__ + "media/assets/icons/purpose-239145db889634b2b77d120f893c39cd.svg";